export const PRAETORIA_API_BASE_URL = "https://praetoria.praetor-notariat.com";

// Version des CGU (src/taskpane/cgu.html) actuellement acceptée par ce build du plugin.
// DOIT rester strictement synchronisée avec PRAETOR_CGU_VERSION dans le .env du serveur
// praetoria -- un décalage entre les deux bloque tous les notaires avec un 409 permanent
// sur POST /email/cgu/accept (voir acceptCgu dans praetoria.ts). À chaque mise à jour du
// texte de cgu.html : changer cette constante ET PRAETOR_CGU_VERSION côté serveur, dans
// le même déploiement.
export const CGU_VERSION = "2026-09-09";

declare const PRAETORIA_API_TOKEN: string;

export function getPraetoriaApiToken(): string {
  return typeof PRAETORIA_API_TOKEN === "string" ? PRAETORIA_API_TOKEN : "";
}
